// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  let variant = evt.detail.variant;
  let $form = document.querySelector('.quick-product--wrap.is-visible .product-form__controls-group')  || document.querySelector('.product-form__controls-group');
  if (!$form) return;
  $form.classList.toggle('product-form--soldout', !variant.available);
});



const EC_ROUTES_ROOT = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

const UTILS = (() => {
  const EC_CART_DELAY = 300;

  const CartAddUrl = () => {
    return EC_ROUTES_ROOT() + 'cart/add.js';
  };

  const PairIdsOf = (items) => {
    if (!Array.isArray(items)) return [];
    const ids = [];
    items.forEach((it) => {
      const p = it && it.properties;
      if (p && p._pair_id !== undefined && p._pair_id !== null && p._pair_id !== '') ids.push(String(p._pair_id));
    });
    return ids;
  };

  const UndoPairAdd = async (ids, before) => {
    const after = await GetCartJson();
    const prev = {};
    before.items.forEach((i) => { prev[i.key] = i.quantity; });
    const updates = {};
    after.items.forEach((i) => {
      const p = i.properties || {};
      if (ids.indexOf(String(p._pair_id)) === -1) return;
      const q = prev[i.key] || 0;
      if (i.quantity !== q) updates[i.key] = q;
    });
    if (!Object.keys(updates).length) return;
    await fetch(EC_ROUTES_ROOT() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  };

  let CartLock = Promise.resolve();
  const WithCartLock = (fn) => {
    const run = CartLock.then(fn);
    CartLock = run.catch(() => {});
    return run;
  };

  const AddItemsToCart = async (itemsToAdd) => {
    const isForm = (typeof FormData !== 'undefined') && (itemsToAdd instanceof FormData);
    const opts = {
      method: 'POST',
      body: isForm ? itemsToAdd : JSON.stringify({ items: itemsToAdd })
    };
    if (!isForm) opts.headers = { 'Content-Type': 'application/json' };
    const ids = isForm ? [] : PairIdsOf(itemsToAdd);
    if (!ids.length) return fetch(CartAddUrl(), opts);
    return WithCartLock(async () => {
      const before = await GetCartJson().catch(() => null);
      const res = await fetch(CartAddUrl(), opts);
      if (!res.ok && before) {
        try { await UndoPairAdd(ids, before); } catch (e) {}
      }
      return res;
    });
  };

  const GetCartJson = () => {
    return fetch(EC_ROUTES_ROOT() + 'cart.js').then((res) => res.json());
  }

  const RefreshCart = async (options) => {
    const o = options || {};
    const delay = typeof o.delay === 'number' ? o.delay : EC_CART_DELAY;
    const reloadOnCartPage = o.reloadOnCartPage !== false;
    const closeQuickView = o.closeQuickView !== false;

    let cart = await GetCartJson();

    if (typeof o.onCart === 'function') o.onCart(cart);

    let isCartPage = document.querySelectorAll('.template-cart').length !== 0;
    if (reloadOnCartPage && isCartPage) {
      window.location.reload();
      return cart;
    }

    if (typeof window.r$1 !== 'undefined') {
      window.r$1("quick-cart:updated");
      window.r$1("cart:updated", { cart });
    }

    // Need a delay to allow quick-cart to refresh
    setTimeout(function () {
      if (typeof window.r$1 !== 'undefined') {
        window.r$1("quick-cart:open");
      }

      if (!closeQuickView) return;
      let $quickModal = document.querySelector('.quick-product--wrap.modal.active');
      if ($quickModal) {
        let $close = $quickModal.querySelector('[data-modal-close]');
        if ($close) $close.dispatchEvent(new Event('click', {bubbles: true}));
      }
    }, delay);

    return cart;
  }

  const AddAndRefresh = async (itemsToAdd, options) => {
    const res = await AddItemsToCart(itemsToAdd);
    if (!res.ok) throw new Error('add failed');
    await res.json();
    return RefreshCart(options);
  };

  const BuyItNow = async (itemsToAdd) => {
    const res = await AddItemsToCart(itemsToAdd);
    if (!res.ok) throw new Error('add failed');
    await res.json();
    await fetch(EC_ROUTES_ROOT() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'checkout_method': 'buy_it_now' } })
    });
    window.location.href = '/checkout';
  };

  const BindBuyItNow = (el, buildItems, options) => {
    const o = options || {};
    el.addEventListener('click', async (e) => {
      let $paymentWrapper = e.target.closest('[data-shopify="payment-button"]');
      if (!$paymentWrapper) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      let itemsToAdd = buildItems(e, $paymentWrapper);
      if (!itemsToAdd || !itemsToAdd.length) return;

      try {
        await BuyItNow(itemsToAdd);
      } catch (err) {
        if (typeof o.onError === 'function') o.onError(err);
        else console.error('Buy It Now add failed:', err);
      }
    }, true);
  };

  const EcCart = {
    addItems: AddItemsToCart,
    getCart: GetCartJson,
    refreshCart: RefreshCart,
    addAndRefresh: AddAndRefresh,
    buyItNow: BuyItNow,
    bindBuyItNow: BindBuyItNow,
    lock: WithCartLock,
    DELAY: EC_CART_DELAY
  };

  const GetLocation = async () => {
    const SESSION_KEY = 'loc_country';
    let location = sessionStorage.getItem(SESSION_KEY);
    if (!location) {
      location = await fetch('/browsing_context_suggestions.json').then(res => res.json());
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(location));
    }
    else {
      location = JSON.parse(location);
    }
    return location;
  }

  const FormatMoney = (value) => window.ECMoney(value, 'symbolSpace');

  return {
    AddItemsToCart,
    GetCartJson,
    RefreshCart,
    GetLocation,
    FormatMoney,
    EcCart
  };
})();

document.addEventListener('init-filter-tryon', (e) => {
  e.currentTarget.addEventListener('click', (evt) => {
    let isMobile = window.matchMedia('(max-width: 479px)').matches;
    let isToggleBtn = (evt.target.classList.contains('tryon-button-img') || 
      evt.target.classList.contains('tryon-button-button') || 
      evt.target.closest('.close-btn') !== null);

    if (isToggleBtn) {
      if (isMobile) {
        let $container = evt.target.closest('[data-tryon_url]');
        let tryon_url = $container.dataset.tryon_url;
        window.open(tryon_url, '_blank');
        return;
      }
      let $tryon = evt.target.closest('.tryon-filter');
      $tryon.classList.toggle('visible');
    }
  });
});

document.querySelectorAll('[href="#gorgias-chat-open"]').forEach(($link) => {
  $link.addEventListener('click', (e) => {
    e.preventDefault();
    if (window.GorgiasChat) {
      GorgiasChat.open();
    }
  });
});

document.addEventListener('alpine:init', () => {
  Alpine.data('freeshipping_callout', () => ({
      settings: null,
      location: null,
      init() {
        let am = this;
        (async() => {
          let location = await UTILS.GetLocation();
          am.location = location;
        })();
      },
      setSettings(settings) {
        this.settings = Object.assign(settings, FS_SETTINGS);
      },
      getThreshold() {
        let am = this;
        let country = am.location ? am.location.detected_values.country.handle : '';
        let isGroup1 = am.settings.group_1_country.replaceAll(', ', ',').split(',').indexOf(country) !== -1;
        let threshold = isGroup1 ? am.settings.group_1_threshold : am.settings.rest_threshold;
        return threshold;
      },
      getMessage() {
        let am = this;
        let message = am.settings.message;
        return message
          .replaceAll('[threshold]', `<span class="money">$${ am.settings.group_1_threshold }</span>`)
          .replaceAll('[threshold2]', `<span class="money">$${ am.settings.rest_threshold }</span>`);
      }
  }))

  Alpine.data('ConvertPrescription', () => ({
    $section: null,
    initialized: false,
    init() {
      let am = this;
      document.addEventListener('init-ConvertPrescription', (e) => {
        if (am.initialized) return;

        am.$section = e.target;
        am.initialized = true;
      });
    },
    Convert() {
      let am = this;
      if (!am.$section) return;
      let $section = am.$section;
      const ODsphere = parseFloat($section.querySelector('#ODsphere').value);
      const ODcylinder = parseFloat($section.querySelector('#ODcylinder').value);
      const ODaxis = parseFloat($section.querySelector('#ODaxis').value);
      const OSsphere = parseFloat($section.querySelector('#OSsphere').value);
      const OScylinder = parseFloat($section.querySelector('#OScylinder').value);
      const OSaxis = parseFloat($section.querySelector('#OSaxis').value);

      const convertSphere = (sphere) => {
        if (sphere === 0) {
          return 0;
        } else if (Math.abs(sphere) <= 4) {
          return sphere;
        } else {
          const vertexDistance = 0.012;
          const contactLensSphere = sphere / (1 - (vertexDistance * sphere));
          if (Math.abs(contactLensSphere) < 6) {
            return Math.round(contactLensSphere * 4) / 4;
          } else {
            return Math.round(contactLensSphere * 2) / 2;
          }
        }
      };

      const ODcontactLensSphere = convertSphere(ODsphere);
      const OScontactLensSphere = convertSphere(OSsphere);

      $section.querySelector('#ODcontactLensSphere').value = isNaN(ODcontactLensSphere) ? '' : ODcontactLensSphere.toFixed(2);
      $section.querySelector('#OScontactLensSphere').value = isNaN(OScontactLensSphere) ? '' : OScontactLensSphere.toFixed(2);

      if (!isNaN(ODcylinder) && !isNaN(ODaxis)) {
        $section.querySelector('#ODcontactLensCylinder').value = (Math.round(ODcylinder * 4) / 4).toFixed(2);
        $section.querySelector('#ODcontactLensAxis').value = (Math.round(ODaxis / 10) * 10) % 180 || 180;
      } else {
        $section.querySelector('#ODcontactLensCylinder').value = '';
        $section.querySelector('#ODcontactLensAxis').value = '';
      }

      if (!isNaN(OScylinder) && !isNaN(OSaxis)) {
        $section.querySelector('#OScontactLensCylinder').value = (Math.round(OScylinder * 4) / 4).toFixed(2);
        $section.querySelector('#OScontactLensAxis').value = (Math.round(OSaxis / 10) * 10) % 180 || 180;
      } else {
        $section.querySelector('#OScontactLensCylinder').value = '';
        $section.querySelector('#OScontactLensAxis').value = '';
      }
    }
  }));

  Alpine.data('ReadMoreToggle', (p_options) => ({
    $section: null,
    p_options: p_options,
    isMobile: matchMedia('(max-width:720px)').matches,
    maxChars: p_options.maxChars,
    selector: p_options.selector,
    init() {
      let am = this;
      document.addEventListener('init-ReadMoreToggle', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        if (am.p_options.desktop && !am.isMobile) {
          am.InitReadMoreToggle();
        }
        if (am.p_options.mobile && am.isMobile) {
          am.InitReadMoreToggle();
        }
      });
    },
    InitReadMoreToggle() {
      let am = this;
      let $content = am.$section.querySelector(am.selector);
      let text = $content.textContent;
      let html = $content.innerHTML;
      if (text.length > am.maxChars) {
        let short_text = text.slice(0, 195);
        let ecStr = (window.theme && window.theme.strings && window.theme.strings.ec) || {};
        let more_label = ecStr.read_more || 'More';
        let less_label = ecStr.read_less || 'Less';

        $content.textContent = '';
        $content.insertAdjacentHTML('afterbegin', `
          <span class="short-text">${ short_text }... <a class="toggle-link" href="#">${ more_label }</a></span>
          <span class="full-text">${ html }<a class="toggle-link" href="#">${ less_label }</a></span>
        `);

        $content.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.classList.contains('toggle-link')) {
            e.stopPropagation();
            $content.classList.toggle('active');
          }
        });
      }
    }
  }));

  Alpine.data('CollapsibleRows', () => ({
    $section: null,
    init() {
      let am = this;
      document.addEventListener('init-CollapsibleRows', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        am.ReformatItemsList();
      });
    },
    ReformatItemsList() {
      let am = this;
      let $items = [...am.$section.querySelectorAll('.collapsible-row-list-item')];
      let count = $items.length;
      let midpoint = count / 2;
      $items = [$items.slice(0, midpoint), $items.slice(-midpoint)];

      [1,2].forEach((group_index) => {
        let $group = am.$section.querySelector(`.group--${ group_index }`);
        $items[(group_index - 1)].forEach(($item) => {
          $group.insertAdjacentElement('beforeend', $item);
        });
      });
    }
  }));

  Alpine.data('QtyPair', () => ({
    qty: 1,
    pair_id: Date.now(),
    init() {
      this.$watch('qty', () => {
        this.pair_id = Date.now()
      });
    }
  }));

  Alpine.data('ProductPairSelect', () => ({
    product: null,
    cache: {},
    power_R: '0.00 (non prescription)',
    power_L: '0.00 (non prescription)',
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitEvents();
      this.InitBuyItNowIntercept();
      this.InitPairPrice();
      this.InitInStockDefault();
    },
    InitInStockDefault() {
      let am = this;
      let $modal = am.$el.closest('[data-quick-view-modal]');
      if ($modal && $modal.hasAttribute('data-ec-cart-edit-modal')) return;
      let linked_id = $modal ? null : new URLSearchParams(window.location.search).get('variant');

      let IsAvailable = ($option) => $option.dataset.available !== 'false';

      am.$nextTick(() => {
        [...am.$el.querySelectorAll('select')].forEach(($select) => {
          let $options = [...$select.options];
          let current = $select.selectedIndex;
          let linked = linked_id ? $options.findIndex(($option) => $option.value === linked_id) : -1;
          if (linked !== -1) {
            if (IsAvailable($options[linked])) {
              if (linked === current) return;
              $select.selectedIndex = linked;
              $select.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
            current = linked;
          }
          if (current === -1 || IsAvailable($options[current])) return;

          let next = $options.findIndex(($option, index) => index > current && IsAvailable($option));
          if (next === -1) next = $options.findIndex(IsAvailable);
          if (next === -1) return;

          if (linked !== -1) am.ResetSoldOutSubmit();
          $select.selectedIndex = next;
          $select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    },
    ResetSoldOutSubmit() {
      let am = this;
      let $group = am.cache.$product_main.querySelector('.product-form--soldout');
      if (!$group) return;
      $group.classList.remove('product-form--soldout');

      let $btn = $group.querySelector('[name=add]');
      if (!$btn) return;
      $btn.disabled = false;
      $btn.removeAttribute('aria-disabled');
      $btn.setAttribute('aria-label', $btn.dataset.langAvailable);
      let $text = $btn.querySelector('[data-add-to-cart-text]');
      if ($text) $text.textContent = $btn.dataset.langAvailable;
    },
    InitCache() {
      let am = this;
      am.cache.$product_main = am.$el.closest('.quick-product--wrap') || am.$el.closest('.product__details');
      am.cache.$btn_atc = am.cache.$product_main.querySelector('[name=add]');
      am.cache.$qty = am.cache.$product_main.querySelector('[data-quantity-input]');
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
    },
    InitEvents() {
      let am = this;
      if (!am.cache.$btn_atc) return;

      let $product_main = am.cache.$product_main;

      am.cache.$btn_atc.classList.remove('btn--secondary');
      am.cache.$btn_atc.classList.add('btn--primary');

      $product_main.addEventListener('click', async (e) => {
        let $btn_atc = e.target.closest('[name=add]');
        if (!$btn_atc) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        let $qty = $product_main.querySelector('[data-quantity-input]') || am.cache.$qty;

        let $subscribe = $product_main.querySelector('[data-type="subscription"]');
        let isSubscription = ($subscribe && $subscribe.checked) || false;

        let $options = [...$product_main.querySelectorAll('.variant-picker-pairs select')];
        let itemsToAdd = am.buildPairItems($options, $qty, isSubscription);

        let add_req = await UTILS.EcCart.addItems(itemsToAdd);
        am.pairStockError(add_req.ok === false);
        if (add_req.ok) {
          UTILS.EcCart.refreshCart();
        }
      }, true);
    },
    pairStockError(show) {
      let $err = this.cache.$product_main && this.cache.$product_main.querySelector('[data-quantity-error]');
      if (!$err) return;
      if (show) $err.innerText = $err.getAttribute('data-fallback-error-message');
      $err.classList.toggle('hidden', !show);
    },
    buildPairItems($options, $qty, isSubscription) {
      let am = this;
      let $product_main = am.cache.$product_main;
      let pair_id = Date.now();
      return $options.map(($select, pair_eye_idx) => {
        let variant_id = $select.value;
        let item = {
          quantity: $qty.value,
          id: variant_id,
          properties: {
            'Power R': $options[0].querySelector('option:checked').dataset.title,
            'Power L': $options[1].querySelector('option:checked').dataset.title,
            '_pair': 'true',
            '_pair_id': pair_id,
            '_eye': pair_eye_idx === 0 ? 'R' : 'L'
          }
        };

        if (isSubscription) {
          let variant = am.product.variants.find(v => variant_id == v.id);
          let selected_frequency_index = $product_main.querySelector('[name=subs_interval]').selectedIndex;
          let selling_plan = variant.selling_plan_allocations[selected_frequency_index];
          item.selling_plan = selling_plan.selling_plan_id;
        }
        return item;
      });
    },
    InitBuyItNowIntercept() {
      let am = this;
      if (!am.cache.$btn_atc) return;

      let $product_main = am.cache.$product_main;

      UTILS.EcCart.bindBuyItNow($product_main, () => {
        let $qty = $product_main.querySelector('[data-quantity-input]') || am.cache.$qty;

        let $subscribe = $product_main.querySelector('[data-type="subscription"]');
        let isSubscription = ($subscribe && $subscribe.checked) || false;

        let $options = [...$product_main.querySelectorAll('.variant-picker-pairs select')];
        if ($options.length !== 2) return null;

        return am.buildPairItems($options, $qty, isSubscription);
      }, {
        onError: (err) => {
          am.pairStockError(true);
          console.error('Buy It Now pair add failed:', err);
        }
      });
    },
    InitPairPrice() {
      let am = this;
      let $product_main = am.cache.$product_main;
      if (!$product_main || !am.product || !am.product.variants) return;

      let $selects = [...am.$el.querySelectorAll('select')];
      if ($selects.length !== 2) return;

      let $price_wrap = $product_main.querySelector('.product__block--product-header .product__price')
        || $product_main.querySelector('.product__price');
      if (!$price_wrap) return;
      if (!$price_wrap.querySelector('[data-price] .money')) return;

      let $compare = $price_wrap.querySelector('[data-compare-price]');
      let $discount = $price_wrap.querySelector('[data-discount-display]');
      let original = {
        compare: $compare ? $compare.innerHTML : null,
        discount: $discount ? $discount.innerHTML : null
      };

      let money_format = (window.theme && window.theme.moneyFormat) || '';
      let MoneyText = (cents) => {
        let amount = UTILS.FormatMoney(cents).replace(/^\$\s*/, '');
        if (money_format.indexOf('{{amount}}') === -1
          && money_format.indexOf('{{ amount }}') === -1) return UTILS.FormatMoney(cents);
        return money_format
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/<[^>]*>/g, '');
      };

      let PriceOf = (variant_id) => {
        let variant = am.product.variants.find(v => String(v.id) === String(variant_id));
        return variant ? variant.price : null;
      };

      let base_sum = PriceOf($selects[0].value) + PriceOf($selects[1].value);

      let Update = () => {
        let price_R = PriceOf($selects[0].value);
        let price_L = PriceOf($selects[1].value);
        if (price_R === null || price_L === null) return;
        let sum = price_R + price_L;

        let $money = $price_wrap.querySelector('[data-price] .money');
        if (!$money) return;

        $money.setAttribute('data-ec-usd', (sum / 100).toFixed(2));
        $money.removeAttribute('data-ec-cur');
        $money.textContent = MoneyText(sum);

        let is_base = sum === base_sum;
        if ($compare && original.compare !== null) $compare.innerHTML = is_base ? original.compare : '';
        if ($discount && original.discount !== null) $discount.innerHTML = is_base ? original.discount : '';
      };

      $selects.forEach(($select) => $select.addEventListener('change', Update));
      Update();
    }
  }));

  Alpine.data('CartQtyPair', (qty, lineitem_key, isPairSeparate) => ({
    qty: qty,
    applied: qty,
    lineitem_key: lineitem_key,
    isPairSeparate: isPairSeparate,
    init() {
      let am = this;
      am.$watch('qty', am.UpdateQuantity.bind(am));
    },
    ShowError(show) {
      let $wrap = this.$el.parentElement;
      let $err = $wrap && $wrap.querySelector('.quick-cart__item-error, .cart__form-item-error');
      if ($err) $err.classList.toggle('hidden', !show);
    },
    UpdateQuantity() {
      let am = this;
      let qty = parseInt(am.qty, 10);
      if (isNaN(qty) || qty < 0 || qty === am.applied) return;
      (async() => {
        let cart = await fetch(EC_ROUTES_ROOT() + 'cart.js').then(res => res.json());
        let line_item = cart.items.find(item => item.key == am.lineitem_key);
        if (!line_item || !line_item.properties) return;

        let updates = {};
        let adds = [];
        let pair_id = line_item.properties['_pair_id'];

        if (pair_id) {
          let groups = {};
          let order = [];
          cart.items.forEach((item) => {
            if (!item.properties || item.properties._pair_id != pair_id) return;
            let k = item.properties._eye || ('v' + item.variant_id);
            if (!groups[k]) {
              groups[k] = [];
              order.push(k);
            }
            groups[k].push(item);
          });
          order.forEach((k) => {
            let lines = groups[k];
            let first = lines[0];
            let perLine = order.length > 1 || !!first.properties._eye;
            let target = perLine ? qty : qty * 2;
            let have = lines.reduce((sum, item) => sum + item.quantity, 0);
            if (target > have) {
              let add = { id: first.variant_id, quantity: target - have, properties: first.properties };
              if (first.selling_plan_allocation && first.selling_plan_allocation.selling_plan) {
                add.selling_plan = first.selling_plan_allocation.selling_plan.id;
              }
              adds.push(add);
            } else {
              lines.forEach((item, i) => {
                let want = i === 0 ? target : 0;
                if (item.quantity !== want) updates[item.key] = want;
              });
            }
          });
        }
        else if (am.isPairSeparate) {
          updates[line_item.key] = qty;
        }
        else {
          updates[line_item.key] = qty * 2;
        }

        if (adds.length) {
          let add_req = await UTILS.EcCart.addItems(adds);
          if (!add_req.ok) {
            am.ShowError(true);
            am.qty = am.applied;
            return;
          }
        }

        if (Object.keys(updates).length) {
          let update_req = await fetch(EC_ROUTES_ROOT() + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          });
          if (!update_req.ok) {
            console.error(update_req);
            return;
          }
        }

        am.applied = qty;
        am.ShowError(false);
        UTILS.RefreshCart();
      })();
    }
  }));

  document.addEventListener('update-main-image', (e) => {
    let $mediaContainer = e.target.closest('.product__media-container');
    if (!$mediaContainer) return;

    let $video = $mediaContainer.querySelector(`[data-video-id="${ e.detail.id }"] video`);
    if (!$video) {
      $mediaContainer.querySelectorAll('video').forEach(($video) => {
        $video.pause();
      });
      return;
    };
    
    $video.controls = true;
    $video.play();
  });

  document.addEventListener('init-media-carousel', (e) => {
    let $mediaContainer = e.target;

    setTimeout(() => {
      let swiper = $mediaContainer.swiper;
      if (!swiper) return;
  
      swiper.on('slideChangeTransitionEnd', () => {
        let $video = $mediaContainer.querySelector('.swiper-slide-active video');
        if (!$video) {
          $mediaContainer.querySelectorAll('video').forEach(($video) => {
            $video.pause();
          });
    
          return;
        }
  
        $video.controls = true;
        $video.play();  
      });  
    }, 2000);
  });

  Alpine.data('DATA', (item) => ({
    init() {
      document.querySelectorAll(`[x-data="DATA('${ item }')"]`).forEach(($item) => {
        let replace_text = '';
        switch(item) {
          case 'fs-threshold-1':
            replace_text = FS_SETTINGS.group_1_threshold;
            break;
          case 'fs-threshold-2':
            replace_text = FS_SETTINGS.rest_threshold;
            break;
          case 'country':
            let loc_country = JSON.parse(sessionStorage.getItem('loc_country'));
            replace_text = `${ loc_country.detected_values.country.name }`;
            break;
        }

        $item.textContent = `$${ replace_text }`;
      });
    }
  }));

  Alpine.data('FreeShipBar', () => ({
    config: {
      threshold_1: 0,
      message_1_inc: '',
      message_1_comp: '',
      fg_title: '',
      threshold_2: 0,
      message_2_inc: '',
      message_2_comp: ''
    },
    flags: {
      progress: 0
    },
    cart: null,
    mounted() {
      let am = this
      am.config.threshold_1 = parseFloat(am.$el.dataset.threshold_1) || 0
      am.config.message_1_inc = am.$el.dataset.message_1_inc
      am.config.message_1_comp = am.$el.dataset.message_1_comp
      am.config.fg_title = am.$el.dataset.fg_title

      am.config.threshold_2 = parseFloat(am.$el.dataset.threshold_2) || 0
      am.config.message_2_inc = am.$el.dataset.message_2_inc
      am.config.message_2_comp = am.$el.dataset.message_2_comp

      if (!am.config.threshold_1 && !am.config.threshold_2) {
        am.$el.classList.add('visually-hidden')
      }

      am.config.message_3 = am.$el.dataset.message_3

      am.CheckProgress()

      document.addEventListener("cart:updated", (e) => {
        am.CheckProgress()
      })
    },
    CheckProgress() {
      let am = this;
      (async() => {
        am.cart = await UTILS.GetCartJson()
        let threshold = am.config.threshold_1
        if (am.config.threshold_2 > am.config.threshold_1) {
          threshold = am.config.threshold_2
        }
        am.flags.progress = (am.cart.total_price / threshold) * 100
      })()
    },
    GetProgressStyle() {
      let am = this
      let obj = {}
      obj['--progress-width'] = `${ am.flags.progress }%`
      return obj
    },
    GetProgressMessage() {
      let am = this
      if (!am.cart) return ''

      let msg = []
      if (am.config.threshold_1) {
        let msg_1 
        let progress_1 = (am.cart.total_price / am.config.threshold_1) * 100
        if (progress_1 < 100) {
          let fg_remaining = am.config.threshold_1 - am.cart.total_price
          msg_1 = am.config.message_1_inc.replace('$X', `<strong><span class=money>${ UTILS.FormatMoney(fg_remaining) }</span></strong>`)
          msg_1 = msg_1.replace('$TITLE', `${ am.config.fg_title }`)
        }
        else {
          msg_1 = am.config.message_1_comp
          msg_1 = msg_1.replace('$TITLE', `${ am.config.fg_title }`)
        }
        msg.push(msg_1)
      }
      if (am.config.threshold_2) {
        let msg_2
        let progress_2 = (am.cart.total_price / am.config.threshold_2) * 100
        if (progress_2 < 100) {
          let fs_remaining = am.config.threshold_2 - am.cart.total_price
          msg_2 = am.config.message_2_inc.replace('$X', `<strong><span class=money>${ UTILS.FormatMoney(fs_remaining) }</span></strong>`)
        }
        else {
          msg_2 = am.config.message_2_comp
        }
        msg.push(msg_2)
      }

      if (am.config.threshold_1 > am.config.threshold_2) {
        msg = msg.reverse()
      }

      return msg.join('<br />')
    }
  }))
});
(() => {
  let busy = false;
  let rerun = false;
  const stateKey = (i) => 'theme_gift_state_' + i;
  const readOfferState = (offer) => {
    const v = sessionStorage.getItem(stateKey(offer.index));
    if (!v) return null;
    const p = v.split('|');
    return p[1] === String(offer.gift_variant) ? p[0] : null;
  };
  const writeOfferState = (offer, st) => sessionStorage.setItem(stateKey(offer.index), st + '|' + offer.gift_variant);

  const CartRequest = (path, body) => fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const RemoveLine = (key) => CartRequest(EC_ROUTES_ROOT() + 'cart/change.js', { id: key, quantity: 0 });

  const GetGiftState = async () => {
    const res = await fetch(EC_ROUTES_ROOT() + '?sections=gift-eligibility').then(r => r.json());
    const html = res['gift-eligibility'];
    if (!html) return null;
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gift-eligibility]');
    return el ? JSON.parse(el.textContent) : null;
  };

  const OfferQualifies = (offer) => {
    if (offer.mode === 'items') {
      return offer.threshold_items > 0 && offer.qualifying_count >= offer.threshold_items;
    }
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    return offer.threshold_amount > 0 && (offer.qualifying_total / 100) / rate >= offer.threshold_amount;
  };

  const colorKey = (i) => 'theme_gift_color_' + i;
  const RX_PROP = /^(power\s*\(?[rl]\)?|sph(\s*\([rl]\))?)$/i;
  const RX_OPTION = /power|sph/i;
  const RX_TOKEN = /^\s*([+-]?\d+\.\d\d)(?![\d.])/;
  const RX_SWAP_CAP = 20;
  const rxFailed = new Set();
  let rxSwaps = 0;

  const ParsePower = (value) => {
    const s = String(value == null ? '' : value);
    if (/plano/i.test(s)) return 0;
    const m = s.match(/[+-]?\d+(?:\.\d+)?/);
    if (!m) return null;
    const n = parseFloat(m[0]);
    return isNaN(n) ? null : n;
  };

  const RxVariants = (offer) => ((offer.rx && offer.rx.variants) || []).map(v => ({ id: v[0], options: v[1] || [] }));

  const RxPowerList = (offer) => {
    const seen = [];
    RxVariants(offer).forEach(v => {
      const n = ParsePower(v.options[offer.rx.power]);
      if (n !== null && !seen.some(x => Math.abs(x - n) < 0.001)) seen.push(n);
    });
    return seen;
  };

  const IsGiftProductLine = (offer, line) => (!!offer.gift_variant && line.variant_id === offer.gift_variant) ||
    (!!offer.rx && !!offer.gift_product && line.product_id === offer.gift_product);

  const LinePowers = (line, powerList) => {
    const out = [];
    const props = line.properties || {};
    Object.keys(props).forEach(k => {
      if (!RX_PROP.test(k.trim())) return;
      const n = ParsePower(props[k]);
      if (n !== null) out.push(n);
    });
    (line.options_with_values || []).forEach(o => {
      if (!RX_OPTION.test(o.name || '')) return;
      const n = ParsePower(o.value);
      if (n !== null) out.push(n);
    });
    String(line.variant_title || '').split(' / ').forEach(seg => {
      const m = seg.match(RX_TOKEN);
      if (!m) return;
      const n = parseFloat(m[1]);
      if (powerList.some(p => Math.abs(p - n) < 0.001)) out.push(n);
    });
    return out;
  };

  const ResolvePower = (target, powerList) => {
    const exact = powerList.find(p => Math.abs(p - target) < 0.001);
    if (exact !== undefined) return exact;
    const lower = powerList
      .filter(p => Math.abs(p) < Math.abs(target) && (p === 0 || Math.sign(p) === Math.sign(target)))
      .sort((a, b) => Math.abs(b) - Math.abs(a));
    if (lower.length) return lower[0];
    const zero = powerList.find(p => Math.abs(p) < 0.001);
    return zero !== undefined ? zero : null;
  };

  const MatchedPower = (offer, cart) => {
    const powerList = RxPowerList(offer);
    let best = null;
    (cart.items || []).forEach(line => {
      if (line.properties && line.properties['_Gifted']) return;
      if (IsGiftProductLine(offer, line)) return;
      LinePowers(line, powerList).forEach(n => {
        if (best === null || Math.abs(n) < Math.abs(best) || (Math.abs(n) === Math.abs(best) && n < best)) best = n;
      });
    });
    return ResolvePower(best === null ? 0 : best, powerList);
  };

  const RxColorOf = (offer, variantId) => {
    if (!offer.rx || offer.rx.color < 0) return null;
    const v = RxVariants(offer).find(x => x.id === variantId);
    return v ? v.options[offer.rx.color] : null;
  };

  const RxVariantFor = (offer, cart, color) => {
    if (!offer.rx) return offer.gift_variant;
    const power = MatchedPower(offer, cart);
    if (power === null) return offer.gift_variant;
    const variants = RxVariants(offer);
    const baseColor = RxColorOf(offer, offer.gift_variant);
    const pick = (c) => variants.find(v => {
      const n = ParsePower(v.options[offer.rx.power]);
      if (n === null || Math.abs(n - power) >= 0.001) return false;
      return offer.rx.color < 0 || c == null || v.options[offer.rx.color] === c;
    });
    const hit = pick(color) || pick(baseColor);
    return hit ? hit.id : offer.gift_variant;
  };

  const RxSwap = async (offer, cart, giftLine) => {
    const color = RxColorOf(offer, giftLine.variant_id);
    if (color) sessionStorage.setItem(colorKey(offer.index), color);
    const target = RxVariantFor(offer, cart, color);
    if (!target || target === giftLine.variant_id) return false;
    const attempt = offer.index + ':' + giftLine.variant_id + '>' + target;
    if (rxFailed.has(attempt) || rxSwaps >= RX_SWAP_CAP) return false;
    rxSwaps++;

    const properties = Object.assign({}, giftLine.properties || {}, { '_Gifted': offer.marker });
    const res = await CartRequest(EC_ROUTES_ROOT() + 'cart/add.js', {
      items: [{ id: target, quantity: 1, properties }]
    });
    if (!res.ok) {
      rxFailed.add(attempt);
      return false;
    }
    const after = await UTILS.GetCartJson();
    const added = after.items.find(i => i.variant_id === target && i.properties && i.properties['_Gifted'] === offer.marker);
    if (!added || added.final_line_price > 0) {
      if (added) await RemoveLine(added.key);
      rxFailed.add(attempt);
      return true;
    }
    if (added.quantity > 1) {
      await CartRequest(EC_ROUTES_ROOT() + 'cart/change.js', { id: added.key, quantity: 1 });
    }
    const fresh = await UTILS.GetCartJson();
    const old = fresh.items.find(i => i.variant_id === giftLine.variant_id && i.properties && i.properties['_Gifted'] === offer.marker);
    if (old) await RemoveLine(old.key);
    return true;
  };

  window.EcGiftRx = { ParsePower, LinePowers, ResolvePower, MatchedPower, RxPowerList, RxVariantFor, RxSwap, GetGiftState };

  const SyncGifts = async (cart) => {
    const state = await GetGiftState();
    if (!state || !state.offers) return false;

    const enabledOffers = state.offers.filter(o => o.enabled && o.gift_variant);
    let changed = false;

    for (const offer of enabledOffers) {
      for (const line of cart.items) {
        if (!IsGiftProductLine(offer, line)) continue;
        const marked = line.properties && line.properties['_Gifted'] === offer.marker;
        if (!marked) {
          if (offer.pricing !== 'discount') {
            await RemoveLine(line.key);
            changed = true;
          }
        } else if (line.quantity > 1) {
          await CartRequest(EC_ROUTES_ROOT() + 'cart/change.js', { id: line.key, quantity: 1 });
          changed = true;
        }
      }
    }

    const superseded = new Set();
    for (const o of enabledOffers) {
      if (!o.supersedes_product) continue;
      if (cart.items.some(i => i.properties && i.properties['_Gifted'] === o.marker)) {
        superseded.add(o.supersedes_product);
      }
    }

    for (const offer of enabledOffers) {
      const giftLine = cart.items.find(i => i.properties && i.properties['_Gifted'] === offer.marker);
      const qualifies = OfferQualifies(offer);
      const isSuperseded = offer.gift_product && superseded.has(offer.gift_product);
      const st = readOfferState(offer);

      if (giftLine && (isSuperseded || (!qualifies && offer.pricing !== 'discount'))) {
        await RemoveLine(giftLine.key);
        sessionStorage.removeItem(stateKey(offer.index));
        changed = true;
        continue;
      }

      if (giftLine) {
        writeOfferState(offer, 'added');
        if (offer.rx && await RxSwap(offer, cart, giftLine)) changed = true;
        continue;
      }

      if (st === 'added' && qualifies && !isSuperseded) {
        writeOfferState(offer, 'dismissed');
        continue;
      }
      if (st === 'dismissed') continue;

      if (qualifies && !isSuperseded) {
        await CartRequest(EC_ROUTES_ROOT() + 'cart/add.js', {
          items: [{ id: RxVariantFor(offer, cart, sessionStorage.getItem(colorKey(offer.index))), quantity: 1, properties: Object.assign({}, offer.props || {}, { '_Gifted': offer.marker }) }]
        });
        const after = await UTILS.GetCartJson();
        const added = after.items.find(i => i.properties && i.properties['_Gifted'] === offer.marker);
        if (!added) continue;
        if (added.final_line_price > 0) {
          await RemoveLine(added.key);
          writeOfferState(offer, 'dismissed');
          continue;
        }
        writeOfferState(offer, 'added');
        changed = true;

        if (offer.supersedes_product) {
          const victim = after.items.find(i =>
            i.product_id === offer.supersedes_product &&
            i.properties && i.properties['_Gifted'] &&
            i.properties['_Gifted'] !== offer.marker
          );
          if (victim) {
            await RemoveLine(victim.key);
            const victimOffer = enabledOffers.find(o => o.gift_product === offer.supersedes_product);
            if (victimOffer) sessionStorage.removeItem(stateKey(victimOffer.index));
          }
        }
      }
    }

    return changed;
  };

  const RunCartAutomation = async () => {
    if (busy) {
      rerun = true;
      return;
    }
    busy = true;
    rerun = false;
    try {
      const giftsChanged = await UTILS.EcCart.lock(async () => {
        const cart = await UTILS.GetCartJson();

        if (!cart.items.length) {
          [1, 2, 3, 4].forEach(n => {
            sessionStorage.removeItem(stateKey(n));
            sessionStorage.removeItem(colorKey(n));
          });
          return false;
        }

        return SyncGifts(cart);
      });

      if (giftsChanged) UTILS.RefreshCart();
    } catch (e) {
      console.error('cart automation failed', e);
    } finally {
      busy = false;
      if (rerun) {
        rerun = false;
        QueueRun();
      }
    }
  };

  let queueTimer;
  const QueueRun = () => {
    clearTimeout(queueTimer);
    queueTimer = setTimeout(RunCartAutomation, 250);
  };

  document.addEventListener('cart:updated', QueueRun);
  document.addEventListener('cart:item-added', QueueRun);

  const CART_MUTATION = /\/cart\/(add|change|update|clear)/;
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = String(args[0] && (args[0].url || args[0]));
    const p = origFetch.apply(this, args);
    if (CART_MUTATION.test(url)) p.then(QueueRun).catch(() => {});
    return p;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) {
      this.addEventListener('loadend', QueueRun);
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', QueueRun);
  } else {
    QueueRun();
  }
})();

(function () {
  var cfgEl = document.getElementById('ec-dc-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }

  var supported = String(cfg.supported || '').split(',')
    .map(function (c) { return c.trim().toUpperCase(); })
    .filter(function (c) { return c && c !== 'USD'; });
  if (!supported.length) return;

  var LS_CUR = 'ec_display_currency';
  var LS_RATES = 'ec_fx_rates';
  var MONEY_RE = /\$\s?(\d[\d,]*(?:\.\d{1,2})?)/;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (err) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (err) {} }

  function cacheLiveRates() {
    if (window.Currency && Currency.rates && Currency.rates.USD) {
      lsSet(LS_RATES, JSON.stringify({ ts: Date.now(), rates: Currency.rates }));
      return true;
    }
    return false;
  }

  function getRates() {
    if (window.Currency && Currency.rates && Currency.rates.USD) return Currency.rates;
    try {
      var cached = JSON.parse(lsGet(LS_RATES) || 'null');
      if (cached && cached.rates && cached.rates.USD) return cached.rates;
    } catch (err) {}
    return (cfg.snapshot && cfg.snapshot.rates) || null;
  }

  var COUNTRY_CUR = {
    CA:'CAD', AU:'AUD', GB:'GBP', JP:'JPY', KR:'KRW', SG:'SGD', HK:'HKD', AE:'AED',
    SA:'SAR', NZ:'NZD', CH:'CHF', LI:'CHF', MX:'MXN', TH:'THB', TW:'TWD', MY:'MYR',
    PH:'PHP', IN:'INR', ID:'IDR', DK:'DKK', SE:'SEK', NO:'NOK', PL:'PLN', CZ:'CZK',
    IL:'ILS', TR:'TRY', ZA:'ZAR', BR:'BRL', CN:'CNY', VN:'VND', QA:'QAR', KW:'KWD', BH:'BHD',
    AT:'EUR', BE:'EUR', CY:'EUR', DE:'EUR', EE:'EUR', ES:'EUR', FI:'EUR', FR:'EUR',
    GR:'EUR', HR:'EUR', IE:'EUR', IT:'EUR', LT:'EUR', LU:'EUR', LV:'EUR', MT:'EUR',
    NL:'EUR', PT:'EUR', SI:'EUR', SK:'EUR', MC:'EUR', AD:'EUR', SM:'EUR', ME:'EUR'
  };

  var GEO_KEY = 'ec_dc_geo';
  function cachedGeoCountry() {
    try {
      var g = JSON.parse(lsGet(GEO_KEY) || 'null');
      if (g && g.c && Date.now() - g.ts < 2592000000) return g.c;
    } catch (err) {}
    return null;
  }

  function targetCurrency() {
    var manual = lsGet(LS_CUR);
    if (manual === 'USD') return 'USD';
    if (manual && supported.indexOf(manual) !== -1) return manual;
    var ctxCur = String(cfg.countryCurrency || '').toUpperCase();
    if (supported.indexOf(ctxCur) !== -1) return ctxCur;
    var ctxC = String(cfg.country || '').toUpperCase();
    var ctxMapped = ctxC ? COUNTRY_CUR[ctxC] : null;
    if (ctxMapped && supported.indexOf(ctxMapped) !== -1) return ctxMapped;
    var geoC = cachedGeoCountry();
    var geoCur = geoC ? COUNTRY_CUR[geoC] : null;
    return geoCur && supported.indexOf(geoCur) !== -1 ? geoCur : 'USD';
  }

  function detectCountry() {
    fetch('/browsing_context_suggestions?source=country_selector&country%5Benabled%5D=true', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c) return;
        lsSet(GEO_KEY, JSON.stringify({ c: c, ts: Date.now() }));
        if (!lsGet(LS_CUR)) pass();
      })
      .catch(function () {});
  }

  var fmtCache = {};
  function fmt(amount, cur, whole) {
    var key = whole ? cur + '#w' : cur;
    var f = fmtCache[key];
    if (!f) {
      try {
        var opts = { style: 'currency', currency: cur, currencyDisplay: (cur === 'USD' || cur === 'CAD') ? 'narrowSymbol' : 'symbol' };
        if (whole) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
        f = new Intl.NumberFormat('en', opts);
      } catch (err) {
        f = { format: function (n) { return cur + ' ' + (whole ? Math.round(n) : n.toFixed(2)); } };
      }
      fmtCache[key] = f;
    }
    return f.format(amount);
  }

  function tagTextNodes() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('$') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest('script,style,noscript,textarea,select,[data-ec-dc-skip],.money')) return NodeFilter.FILTER_REJECT;
        return MONEY_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      var text = node.nodeValue;
      var m;
      while ((m = MONEY_RE.exec(text))) {
        if (m.index > 0) frag.appendChild(document.createTextNode(text.slice(0, m.index)));
        var span = document.createElement('span');
        span.className = 'money';
        span.textContent = m[0];
        frag.appendChild(span);
        text = text.slice(m.index + m[0].length);
      }
      if (text) frag.appendChild(document.createTextNode(text));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function convertSpans(cur, rates) {
    var spans = document.querySelectorAll('span.money');
    for (var i = 0; i !== spans.length; i++) {
      var el = spans[i];
      var usd = el.getAttribute('data-ec-usd');
      if (usd === null) {
        var m = MONEY_RE.exec(el.textContent);
        if (!m) continue;
        usd = m[1].replace(/,/g, '');
        el.setAttribute('data-ec-usd', usd);
      }
      if (el.getAttribute('data-ec-cur') === cur) continue;
      var val = parseFloat(usd);
      if (!isFinite(val)) continue;
      if (cur === 'USD') {
        el.textContent = fmt(val, 'USD');
      } else {
        var rate = rates && rates[cur];
        if (!rate) continue;
        var conv = val / rate;
        var rounded = cfg.rounding === 'whole' && conv >= 10;
        if (rounded) conv = Math.round(conv);
        var wholeDisplay = rounded && !!el.closest('.product-badges,.recommended-products__heading,.ec-ot__title');
        if (rounded && !wholeDisplay) {
          var anc = el.parentElement;
          for (var d = 0; anc && d < 3; d++, anc = anc.parentElement) {
            var atext = anc.textContent || '';
            if (atext.length > 200) break;
            if (/free\s+(?:\w+\s+)?ship/i.test(atext)) { wholeDisplay = true; break; }
          }
        }
        el.textContent = fmt(conv, cur, wholeDisplay);
      }
      el.setAttribute('data-ec-cur', cur);
    }
  }

  function syncSelectors(cur) {
    var wraps = document.querySelectorAll('[data-ec-dc-selector]');
    for (var i = 0; i !== wraps.length; i++) {
      wraps[i].hidden = false;
      var sel = wraps[i].querySelector('select');
      if (sel && sel.value !== cur) sel.value = cur;
    }
  }

  var passQueued = false;
  function pass() {
    passQueued = false;
    var cur = targetCurrency();
    document.documentElement.setAttribute('data-ec-dc', cur);
    syncSelectors(cur);
    if (cur === 'USD' && !document.querySelector('span.money[data-ec-cur]')) return;
    tagTextNodes();
    convertSpans(cur, getRates());
  }
  function queuePass() {
    if (passQueued) return;
    passQueued = true;
    setTimeout(passSilently, 150);
  }
  function passSilently() {
    if (!observer) { pass(); return; }
    observer.disconnect();
    try { pass(); } finally {
      observer.takeRecords();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-ec-dc-selector] select');
    if (!sel) return;
    lsSet(LS_CUR, sel.value);
    pass();
  });

  function start() {
    var ctxCur = String(cfg.countryCurrency || '').toUpperCase();
    var ctxMapped = COUNTRY_CUR[String(cfg.country || '').toUpperCase()];
    var ctxUsable = supported.indexOf(ctxCur) !== -1 || (ctxMapped && supported.indexOf(ctxMapped) !== -1);
    if (!lsGet(LS_CUR) && !ctxUsable && !cachedGeoCountry()) detectCountry();
    var tries = 0;
    (function waitRates() {
      if (cacheLiveRates() || tries++ > 20) { pass(); observe(); return; }
      setTimeout(waitRates, 100);
    })();
  }

  var observer = null;
  function observe() {
    if (observer || !window.MutationObserver) return;
    observer = new MutationObserver(function () {
      if (targetCurrency() === 'USD') return;
      queuePass();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('.product-item');
    if (!item || item.__ecHvOn) return;
    var v = item.querySelector('.ec-card-hover-video video');
    if (!v) return;
    item.__ecHvOn = true;
    if (!v.__ecHvErr) {
      v.__ecHvErr = true;
      v.addEventListener('error', function () {
        var fb = v.getAttribute('data-ec-hv-fallback');
        if (!fb || v.__ecHvFbDone) return;
        v.__ecHvFbDone = true;
        var srcEl = v.querySelector('source');
        if (srcEl) { srcEl.src = fb; v.load(); var rp = v.play(); if (rp && rp.catch) rp.catch(function () {}); }
      }, true);
      var hvLayer = v.closest('.ec-card-hover-video');
      v.addEventListener('playing', function () { hvLayer.setAttribute('data-ec-hv-playing', ''); });
      v.addEventListener('pause', function () { hvLayer.removeAttribute('data-ec-hv-playing'); });
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    item.addEventListener('mouseleave', function leave() {
      item.__ecHvOn = false;
      item.removeEventListener('mouseleave', leave);
      v.closest('.ec-card-hover-video').removeAttribute('data-ec-hv-playing');
      try { v.pause(); v.currentTime = 0; } catch (err) {}
    });
  });
})();


(function () {
  function setNum(el, v) {
    v = String(v);
    if (el.textContent === v) return;
    el.textContent = v;
    var prev = el.style.display;
    el.style.display = 'none';
    void el.offsetWidth;
    el.style.display = prev || '';
  }
  function update(container) {
    var settingsEl = container.querySelector('[data-timer-settings]');
    if (!settingsEl) return;
    var s;
    try { s = JSON.parse(settingsEl.innerHTML); } catch (err) { return; }
    var end;
    if (window.ECTimerTarget) {
      end = window.ECTimerTarget(s);
    } else {
      var tz = s.timeZoneSelection === 'shop' ? ' GMT' + s.shopTimezone : '';
      end = Date.parse(s.month + ' ' + s.day + ', ' + s.year + ' ' + s.hour + ':' + s.minute + tz);
    }
    if (isNaN(end)) return;
    var daysEl = container.querySelector('[data-days]');
    var hoursEl = container.querySelector('[data-hours]');
    var minutesEl = container.querySelector('[data-minutes]');
    var secondsEl = container.querySelector('[data-seconds]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;
    container.classList.add('active');
    var d = end - Date.now();
    if (d < 0) {
      daysEl.innerHTML = 0; hoursEl.innerHTML = 0; minutesEl.innerHTML = 0; secondsEl.innerHTML = 0;
      container.classList.add('complete');
      if (s.hideTimerOnComplete) container.classList.add('hide');
    } else {
      setNum(daysEl, Math.floor(d / 864e5));
      setNum(hoursEl, Math.floor(d % 864e5 / 36e5));
      setNum(minutesEl, Math.floor(d % 36e5 / 6e4));
      setNum(secondsEl, Math.floor(d % 6e4 / 1e3));
    }
  }
  function tickAll() {
    var nodes = document.querySelectorAll('.announcement-bar [data-countdown-timer]');
    if (!nodes.length) return;
    window.requestAnimationFrame(function () { nodes.forEach(update); });
  }
  var boot = function () { tickAll(); setInterval(tickAll, 1000); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function attachFallback(v) {
    if (v.__ecPvErr) return;
    v.__ecPvErr = true;
    v.addEventListener('error', function () {
      var fb = v.getAttribute('data-ec-promo-video-fallback');
      if (!fb || v.__ecPvFbDone) return;
      v.__ecPvFbDone = true;
      var srcEl = v.querySelector('source');
      if (srcEl) { srcEl.src = fb; v.load(); var rp = v.play(); if (rp && rp.catch) rp.catch(function () {}); }
    }, true);
  }

  var margin = (window.matchMedia && window.matchMedia('(min-width: 720px)').matches) ? 200 : 100;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target.querySelector('video');
      if (!v) return;
      if (entry.isIntersecting) {
        if (!v.__ecPvSrcSet) {
          v.__ecPvSrcSet = true;
          var srcEl = v.querySelector('source[data-src]');
          if (srcEl) {
            srcEl.src = srcEl.getAttribute('data-src');
            attachFallback(v);
            v.load();
          }
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (v.__ecPvSrcSet) {
        v.pause();
      }
    });
  }, { rootMargin: margin + 'px 0px' });

  document.querySelectorAll('[data-ec-promo-video]').forEach(function (el) {
    io.observe(el);
  });
})();

(function () {
  function initMask(scope) {
    (scope || document).querySelectorAll('.ec-sfooter__logo-mask').forEach(function (mask) {
      if (mask.__ecSfMask) return;
      var img = mask.parentNode && mask.parentNode.querySelector('.ec-sfooter__logo-img');
      if (!img) return;
      mask.__ecSfMask = true;
      function attach() {
        var src = img.currentSrc;
        if (!src || !img.naturalWidth || mask.__ecSfMaskSrc === src) return;
        mask.__ecSfMaskSrc = src;
        mask.style.setProperty('--ec-sfooter-logo-mask', 'url("' + src + '")');
      }
      function start() {
        img.addEventListener('load', attach);
        if (img.complete) attach();
        else if (img.loading === 'lazy') img.loading = 'eager';
      }
      if (!('IntersectionObserver' in window)) { start(); return; }
      var margin = (window.matchMedia && window.matchMedia('(min-width: 720px)').matches) ? 200 : 100;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        start();
      }, { rootMargin: margin + 'px 0px' });
      io.observe(mask);
    });
  }
  initMask();
  document.addEventListener('shopify:section:load', function (e) { initMask(e.target); });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var START = 1.2, END = 1 / 1.2;
  function init(scope) {
    (scope || document).querySelectorAll('.ec-sfooter').forEach(function (root) {
      if (root.__ecSfSettle) return;
      var wrap = root.querySelector('.ec-sfooter__logo-scale');
      if (!wrap) return;
      root.__ecSfSettle = true;
      var ticking = false, active = false;
      function apply() {
        ticking = false;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (!r.height) return;
        var p = (vh - r.top) / r.height;
        if (p < 0) p = 0; else if (p > 1) p = 1;
        wrap.style.transform = 'scale(' + (START + (END - START) * p) + ')';
      }
      function queue() {
        if (!active || ticking) return;
        ticking = true;
        requestAnimationFrame(apply);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          active = entries[0].isIntersecting;
          if (active) queue();
        }, { rootMargin: '80px' }).observe(root);
      } else {
        active = true;
      }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      queue();
    });
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
